import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import type { ICellEditorParams } from "ag-grid-community";

export const normalizeDateInput = (value: unknown): string => {
  if (!value) return "";
  if (typeof value === "string") {
    if (/^\d{4}-\d{2}-\d{2}$/.test(value.trim())) return value.trim();
    const match = value.trim().match(/^(\d{1,2})[\/-](\d{1,2})[\/-](\d{2,4})$/);
    if (match) {
      const [, dd, mm, yyyy] = match;
      const normalizedYear = yyyy.length === 2 ? `20${yyyy}` : yyyy;
      return `${normalizedYear.padStart(4, "0")}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}`;
    }
  }
  const date = new Date(value as any);
  console.log(date, "date");
  if (Number.isNaN(date.getTime())) return "";
  return date.toISOString().slice(0, 10);
};

type DateCellEditorValue = string;

const DateCellEditor = forwardRef<any, ICellEditorParams>((props, ref) => {
  const [value, setValue] = useState<DateCellEditorValue>(() =>
    normalizeDateInput(props.value),
  );
  const inputRef = useRef<HTMLInputElement>(null);

  useImperativeHandle(ref, () => ({
    getValue: () => value,
    afterGuiAttached: () => {
      inputRef.current?.focus();
    },
  }));

  useEffect(() => {
    setValue(normalizeDateInput(props.value));
  }, [props.value]);

  return (
    <input
      ref={inputRef}
      type="date"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      className="w-full h-full px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:border-blue-500"
    />
  );
});

DateCellEditor.displayName = "DateCellEditor";

export default DateCellEditor;
